var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"opc-drawer",class:{
    'opc-drawer--open': _vm.is,
    'opc-modal': _vm.isModal,
  },style:(_vm.is ? { height: this.height } : {})},[_c('div',{staticClass:"opc-drawer__inner",class:{
      'opc-modal': _vm.isModal,
    }},[_c('div',{staticClass:"opc-drawer__head",class:{
        'opc-modal': _vm.isModal,
      },on:{"touchstart":function($event){$event.stopPropagation();}}},[_c('zm-button',{ref:"opc-drawer-control",attrs:{"data-testid":"checkout-button-17","type":"link","aria-expanded":_vm.is ? 'true' : 'false',"suffix-icon":_vm.suffixIcon},on:{"click":_vm.toggle}},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('div',{staticClass:"opc-drawer__head__slot",class:{
          'opc-modal': _vm.isModal,
        }},[_vm._t("head")],2)],1),_c('div',{ref:"mx_ariaBody",staticClass:"opc-drawer__body",class:{
        'opc-modal': _vm.isModal,
      },style:({ display: _vm.is ? 'block' : 'none' }),attrs:{"role":"dialog","aria-modal":"true","aria-hidden":_vm.is ? 'false' : 'true'},on:{"touchstart":function($event){$event.stopPropagation();}}},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }